import React from 'react'
import styled from 'styled-components/native'
import { SafeAreaProvider, SafeAreaView } from 'react-native-safe-area-context'
import BottomSheetModal from 'APP/Components/BottomSheetModal'
import AddFamilyMemberScreen, {
  type AddFamilyMemberScreenProps,
} from 'APP/Containers/AddFamilyMemberScreen'

const FullHeightBottomSheetModal = styled(BottomSheetModal)`
  height: 100%;
`

const StyledSafeAreaView = styled(SafeAreaView)`
  flex: 1;
`

type AddFamilyMemberModalProps = AddFamilyMemberScreenProps['route']['params'] & {
  onClose: () => void
  isVisible: boolean
  testID?: string
}

const AddFamilyMemberModal: React.FC<AddFamilyMemberModalProps> = ({
  isVisible,
  onClose,
  onAdultAdded,
  onChildAdded,
  testID = 'ADD_FAMILY_MEMBER_MODAL',
}) => {
  return (
    <FullHeightBottomSheetModal
      isVisible={isVisible}
      onClose={onClose}
      containerStyle={{ height: '100%' }}
      hideHeader
      testID={testID}
    >
      <SafeAreaProvider>
        <StyledSafeAreaView edges={['top', 'bottom']}>
          <AddFamilyMemberScreen route={{ params: { onAdultAdded, onChildAdded, onClose } }} />
        </StyledSafeAreaView>
      </SafeAreaProvider>
    </FullHeightBottomSheetModal>
  )
}

export default AddFamilyMemberModal
